export { CorePrinciples } from "./CorePrinciples"
export { About } from './About'
export { Expertise } from './Expertise'
export { Services} from './Services'
export  { Clients } from './Clients'
export { Footer } from './Footer'